import { render, staticRenderFns } from "./PatientPieAnalysis.vue?vue&type=template&id=253e120c&scoped=true"
import script from "./PatientPieAnalysis.vue?vue&type=script&lang=js"
export * from "./PatientPieAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e120c",
  null
  
)

export default component.exports